<template>
  <HourlyChauffeurRate />
</template>
<script>
import HourlyChauffeurRate from "@/components/master/hourlyTariff/HourlyChauffeurRate";
export default {
  components: {
    HourlyChauffeurRate,
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-rental-chauffeur-link-new");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/sellingTariff/HourlyChauffeurRateSelling.vue